/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkRcptSync02Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkRcptSync02ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkRcptSync02FetchStkRcptSync02Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkRcptSync02FetchStkRcptSync02Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkRcptSync02AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkRcptSync02RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkRcptSync02SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkRcptSync02SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const stkRcptSync02SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkRcptSync02Types.STK_RCPT_SYNC02_RESET_TIMESTAMP]: stkRcptSync02ResetTimestamp,
  [StkRcptSync02Types.STK_RCPT_SYNC02_FETCH_STK_RCPT_SYNC02_LOADING]: stkRcptSync02FetchStkRcptSync02Loading,
  [StkRcptSync02Types.STK_RCPT_SYNC02_FETCH_STK_RCPT_SYNC02_SUCCESS]: stkRcptSync02FetchStkRcptSync02Success,
  [StkRcptSync02Types.STK_RCPT_SYNC02_ADD_SELECTED_DOCUMENTS]: stkRcptSync02AddSelectedDocuments,
  [StkRcptSync02Types.STK_RCPT_SYNC02_REMOVE_SELECTED_DOCUMENTS]: stkRcptSync02RemoveSelectedDocuments,
  [StkRcptSync02Types.STK_RCPT_SYNC02_SET_WORKSPACE_VISIBLE]: stkRcptSync02SetWorkspaceVisible,
  [StkRcptSync02Types.STK_RCPT_SYNC02_SYNC_LOADING]: stkRcptSync02SyncLoading,
  [StkRcptSync02Types.STK_RCPT_SYNC02_SYNC_NOW_SUCCESS]: stkRcptSync02SyncNowSuccess
});
